import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import CommentOutlineIcon from '../../../Icons/24x24/CommentOutline';
import { NotificationType } from '../../../Notifications/redux/types';
import { addNotification, removeNotification, } from '../../../Notifications/redux/actionCreators';
import { ReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import TextButton from '../../../Buttons/TextButton';
import { expandAndFocusCommentPanel } from '../../../DeviationPage/redux/actions';
var LEAVE_A_COMMENT_NOTIFICATION_ID = 9999;
export default function useLeaveACommentNotification(deviation, buttonClassName) {
    var dispatch = useDispatch();
    var dipatchedExpandAndFocusCommentPanel = useCallback(function () {
        dispatch(removeNotification(LEAVE_A_COMMENT_NOTIFICATION_ID));
        dispatch(expandAndFocusCommentPanel(deviation, 'primary'));
    }, [dispatch, deviation]);
    var notificationOnDownload = useCallback(function () {
        dispatch(addNotification(NotificationType.Generic, {
            id: LEAVE_A_COMMENT_NOTIFICATION_ID,
            cardProps: {
                iconComponent: CommentOutlineIcon,
                backgroundDeviation: deviation,
                multiLine: true,
                duration: 10000,
            },
            message: (React.createElement(LeaveACommentNotificationContent, { className: buttonClassName, onClick: dipatchedExpandAndFocusCommentPanel })),
        }));
    }, [
        buttonClassName,
        dipatchedExpandAndFocusCommentPanel,
        dispatch,
        deviation,
    ]);
    return notificationOnDownload;
}
export var LeaveACommentNotificationContent = function (_a) {
    var className = _a.className, onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(Trans, { i18nKey: "actionbar.mobilePcp.notificationContent" },
            "Thanks for downloading.",
            React.createElement("br", null),
            "Show the artist some love!"),
        React.createElement(ReverseTheme, null,
            React.createElement(TextButton, { className: className, size: "medium", variant: "main", onClick: onClick }, t('actionbar.mobilePcp.leaveAComment')))));
};
//# sourceMappingURL=useLeaveACommentNotification.js.map